import { Button, useTheme } from "@mui/material";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import __ from "src/utils/Translations";
import { useCompanyId } from "src/Pages/Company/CompanyContext";
import { usePermission } from "src/utils/hooks/permissions/usePermissions";
import {
  organizationStructureAreaExport,
  organizationStructureAreaImport,
} from "src/utils/RoleBasedSecurity/permissions";
import useIsAhr from "src/utils/hooks/useIsAhr";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import FEATURE_FLAGS from "src/utils/constants/featureFlags";

export interface IDataCards {
  mainText: string;
  secondaryText: string;
  type: "download" | "upload";
  actionButtons: ReactNode;
}

const Area = () => {
  const companyId = useCompanyId();
  const theme = useTheme();
  const isAhr = useIsAhr();

  const hasImportExportAreasTabEnabled = useFeatureIsOn(
    FEATURE_FLAGS.ORGANIZATION_STRUCTURE_IMPORT_EXPORT_AREAS_TAB
  );

  const hasPermissionsStructureAreaImport = usePermission(
    organizationStructureAreaImport
  );

  const hasPermissionsStructureAreaExport = usePermission(
    organizationStructureAreaExport
  );

  return (
    <>
      {hasImportExportAreasTabEnabled &&
        (hasPermissionsStructureAreaImport ||
          hasPermissionsStructureAreaExport) && (
        <Button
          component={Link}
          to={
            isAhr
              ? "/ahr/organization-structure/import-export-area-data"
              : `/company/edit/${companyId}/organization-structure/import-export-area-data`
          }
          data-testid="os__import-export-button"
          variant="outlined"
          size="large"
          sx={{
            margin: "0 0 0 auto",
            [theme.breakpoints.down("md")]: {
              margin: "unset",
              width: "100%",
            },
          }}
        >
          {__("Importuj / eksportuj")}
        </Button>
      )}
    </>
  );
};

export default Area;
